var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconProfileCircle(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 35,
    viewBox: "0 0 34 35",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.9997 3.33594C9.17968 3.33594 2.83301 9.6826 2.83301 17.5026C2.83301 25.3226 9.17968 31.6693 16.9997 31.6693C24.8197 31.6693 31.1663 25.3226 31.1663 17.5026C31.1663 9.6826 24.8197 3.33594 16.9997 3.33594ZM16.9997 9.0026C19.7338 9.0026 21.958 11.2268 21.958 13.9609C21.958 16.6951 19.7338 18.9193 16.9997 18.9193C14.2655 18.9193 12.0413 16.6951 12.0413 13.9609C12.0413 11.2268 14.2655 9.0026 16.9997 9.0026ZM16.9997 28.8359C14.1238 28.8359 10.7238 27.6743 8.30134 24.7559C10.7828 22.809 13.8456 21.7509 16.9997 21.7509C20.1537 21.7509 23.2166 22.809 25.698 24.7559C23.2755 27.6743 19.8755 28.8359 16.9997 28.8359Z",
    fill: "#911A1E"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconProfileCircle);
export default __webpack_public_path__ + "static/media/icon-profile-circle.c79ac041be1ced2f9e5a26d26ade0fa8.svg";
export { ForwardRef as ReactComponent };